export enum LicenseFeatureName {
  CAMPAIGN_MANAGEMENT_STATIC = "campaign_management_static",
  CARTOGRAPHY_FULL = "cartography_full",
  DASHBOARD_FULL = "dashboard_full",
  DATAVIZ_DEVICE = "dataviz_device",
  INTERFACES_THIRD_PARTY = "interfaces_third_party",
  STATIC_CHART_CERTIFICATE_STATE = "static_chart_certificate_state",
  STATIC_CHART_DEVICE_CONNECTIVITY = "static_chart_device_connectivity",
  STATIC_CHART_DEVICE_STATE = "static_chart_device_state",
  STATIC_CHART_FIRMWARE_DISTRIBUTION = "static_chart_firmware_distribution",
}
